import { useNavigate } from "react-router-dom";
import styles from "./ChatWidget.module.scss";
import { FC } from "react";
import React from "react";

const ChatWidget: FC = () => {
  const redirectUrl = "https://support.yougotagift.com/hc/en-us#b2b-support";

  const handleChatBotClick = () => {
    window.open(redirectUrl, "_blank");
  };

  const [showText, setShowText] = React.useState(false);

  const handleMouseEnter = () => {
    setShowText(true);
  };

  const handleMouseLeave = () => {
    setShowText(false);
  };

  return (
    <>
      <div className={styles["chat-bot-wrapper"]}>
        <div
          className={styles["chat-bot"]}
          onClick={handleChatBotClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <img
            src={"/images/help-lady.svg"}
            alt="Chatbot"
            className={styles["bot-img__img"]}
          />
          <div className={styles["chat-bot__content"]}>
            {showText && (
              <h4 className={styles["chat-bot__content__title"]}>Get Help</h4>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ChatWidget;
